import MobileLayout from "../../components/General/MobileLayout/MobileLayout";
import BottomNavBar from "../../components/BottomNavBar";
import GluceraButton from "../../components/common/GluceraButton";
import { BellOutlined } from "@ant-design/icons";

const ConnectToFitbitPage = () => {
  const handleConnectToFitbit = () => {
    // Add Fitbit connection logic here
  };

  return (
    <MobileLayout>
      <div className="scrollbar-hide mx-auto min-h-screen w-full max-w-[400px] overflow-auto bg-[#171916] pb-16">
        {/* Header */}
        <div className="flex items-center justify-between px-4 pb-2 pt-4">
          <div className="flex items-center">
            <h1 className="text-title3 font-bold text-white">
              Today&apos;s Activities
            </h1>
          </div>
          <div className="relative">
            <button className="flex h-10 w-10 items-center justify-center rounded-full bg-[#414141] p-2">
              <BellOutlined className="text-title3 text-white" />
            </button>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex flex-1 flex-col items-center justify-center px-6 py-20">
          {/* Message Text */}
          <div className="mb-8 text-center">
            <p className="text-title3 font-medium leading-relaxed text-white">
              Please Connect To Fitbit For
            </p>
            <p className="text-title3 font-medium leading-relaxed text-white">
              Improved Results.
            </p>
          </div>

          {/* Connect Button */}
          <div className="w-full max-w-xs">
            <GluceraButton
              onClick={handleConnectToFitbit}
              className="w-full text-callout font-semibold"
              style={{
                padding: "14px 20px",
                minHeight: "50px",
              }}
            >
              Connect to Fitbit
            </GluceraButton>
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <BottomNavBar />
    </MobileLayout>
  );
};

export default ConnectToFitbitPage;
